<template>
  <BForm
    class="formulario"
    @submit.prevent="podeGravar">

    <InputSugestaoFilial
      label="Filial*"
      name="inputFilial"
      class="input__filial"
      v-model="form.filial"
      v-validate="'required'"
      :errorsBag="errors" />

    <InputSugestaoProdutos
      ref="refInputProduto"
      label="Produto*"
      name="inputProduto"
      class="input__produto"
      v-model="form.produto"
      v-validate="'required'"
      :errorsBag="errors" />

    <InputBasico
      ref="inputQuantidade"
      type="number"
      name="nomeInput"
      label="Quantidade*"
      class="input__quantidade"
      v-model="form.quantidade"
      v-validate="'required|min:1'"
      :errorsBag="errors"
      :upperCase="true" />


    <div class="botao__container">
      <BButton
        type="submit"
        class="botao"
        variant="primary">
        Gravar
      </BButton>

      <BButton
        @click.prevent="sair"
        class="botao"
        variant="outline-primary">
        Sair
      </BButton>
    </div>
  </BForm>
</template>

<script>
import { BForm, BButton } from 'bootstrap-vue/es/components'
import FormularioCadastroMixin from '@/mixins/FormularioCadastroMixin'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputSugestaoFilial from '../../../components/inputs/sugestao/InputSugestaoFilial.vue'
import InputSugestaoProdutos from '../../../components/inputs/sugestao/InputSugestaoProdutos.vue'
import localstorage from '../../../../autenticacao/localstorage/autenticacao.localstorage'

export default {
  name: 'EntradasCadastroForm',
  mixins: [FormularioCadastroMixin],
  components: {
    BForm,
    BButton,
    InputBasico,
    InputSugestaoFilial,
    InputSugestaoProdutos,
  },
  mounted() {
    this.$refs.inputFilial.focar()
  },
  methods: {
    valoresIniciaisForm() {
      return {
        filial: null,
        produto: '',
        quantidade: 0,
      }
    },
    retornaCamposGravar() {
      return this.form
    },
    podeGravar() {
      this.form.dataEntrada = new Date()
      this.form.usuarioEntrada = localstorage.getUserObj().usuario
      this.gravar()
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.formulario {
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: $small-size) {
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 0.8em;
  }

  @media (min-width: $extra-large-size) {
    width: $medium-size;
  }
}

.input {
  &__filial {
    @media (min-width: $small-size) {
      grid-column: 1 / 6;
    }
  }

  &__produto {
    @media (min-width: $small-size) {
      grid-column: 6 / -1;
    }
  }

  &__quantidade {
    @media (min-width: $small-size) {
      grid-column: 1 / 4;
    }
  }

}

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

</style>
